const Label = ({ children }) => {
  return (
    <span style={{ fontWeight: "600", fontSize: "1.1em", margin: ".5rem 0" }}>
      {children}
    </span>
  );
};

export default Label;
